/* eslint-disable prefer-regex-literals */

class CamelCaseRegexSingleton {
  static #NILC_REGEX
  static #NON_NILC_REGEX

  static getNilc() {
    if ( !CamelCaseRegexSingleton.#NILC_REGEX ) {
      CamelCaseRegexSingleton.#NILC_REGEX = new RegExp( '([^[\\p{L}\\d]+|(?<=[\\p{Ll}\\d])(?=\\p{Lu})|(?<=\\p{Lu})(?=\\p{Lu}[\\p{Ll}\\d])|(?<=[\\p{L}\\d])(?=\\p{Lu}[\\p{Ll}\\d]))', 'gu' )
    }

    return CamelCaseRegexSingleton.#NILC_REGEX
  }

  static getNonNilc() {
    if ( !CamelCaseRegexSingleton.#NON_NILC_REGEX ) {
      CamelCaseRegexSingleton.#NON_NILC_REGEX = new RegExp( '([^\\p{L}\\d]+|(?<=\\p{L})(?=\\d)|(?<=\\d)(?=\\p{L})|(?<=[\\p{Ll}\\d])(?=\\p{Lu})|(?<=\\p{Lu})(?=\\p{Lu}\\p{Ll})|(?<=[\\p{L}\\d])(?=\\p{Lu}\\p{Ll}))', 'gu' )
    }

    return CamelCaseRegexSingleton.#NON_NILC_REGEX
  }
}

// Source: https://stackoverflow.com/questions/18379254/regex-to-split-camel-case

function split( str, options ) {

  const opts = options || {}
  const separator = opts.separator || ' '
  const nilc = opts.numberIsLowercase === true
  let r = str
  
  try {
    if ( nilc ) {
      r = r.replace( CamelCaseRegexSingleton.getNilc(), separator )
    } else {
      r = r.replace( CamelCaseRegexSingleton.getNonNilc(), separator )
    }
  } catch ( err ) {
    r = r.replace( /([a-z])([A-Z][a-z])/g, '$1 $2' )
      .replace( /[_-]/g, ' ' )
      .replace( /([A-Z][a-z])([A-Z])/g, '$1 $2' )
      .replace( /([a-z])([A-Z]+[a-z])/g, '$1 $2' )
      .replace( /([A-Z]+)([A-Z][a-z][a-z])/g, '$1 $2' )
      .replace( /([a-z]+)([A-Z0-9]+)/g, '$1 $2' )
      .replace( /([A-Z]+)([A-Z][a-rt-z][a-z]*)/g, '$1 $2' )
      .replace( /([0-9])([A-Z][a-z]+)/g, '$1 $2' )
      .replace( /([A-Z]+)([0-9]+)/g, '$1 $2' )
      .replace( /([0-9]+)([A-Z]+)/g, '$1 $2' )
      .trim()
  }

  if ( opts.toUpper ) {
    r = r.toUpperCase()
  } else if ( opts.toLower ) {
    r = r.toLowerCase()
  } else if ( opts.toCamel ) {
    r = r.toLowerCase().split( separator )
    for ( let n = 1; n < r.length; n++ ) {
      r[n] = r[n][0].toUpperCase() + r[n].substring( 1 )
    }
    r = r.join( '' )
  } else if ( opts.toPascal ) {
    r = r.toLowerCase().split( separator )
    for ( let n = 0; n < r.length; n++ ) {
      r[n] = r[n][0].toUpperCase() + r[n].substring( 1 )
    }
    r = r.join( '' )
  } else if ( opts.toTitle ) {
    r = r.toLowerCase().split( separator )
    for ( let n = 0; n < r.length; n++ ) {
      r[n] = r[n][0].toUpperCase() + r[n].substring( 1 )
    }
    r = r.join( ' ' )
  }
  return r
}

function toCamelCase( str ) {
  return split( str, { separator : ' ', toCamel : true } )
}

function toPascalCase( str ) {
  return split( str, { separator : ' ', toPascal : true } )
}

function toSnakeCase( str ) {
  return split( str, { separator : '_', toLower : true } )
}

function toKebabCase( str ) {
  return split( str, { separator : '-', toLower : true } )
}

function toScreamingSnakeCase( str ) {
  return split( str, { separator : '_', toUpper : true } )
}

function toScreamingKebabCase( str ) {
  return split( str, { separator : '-', toUpper : true } )
}

function toTitleCase( str ) {
  return split( str, { separator : ' ', toTitle : true } )
}

const toMacroCase = toScreamingSnakeCase

export { 
  split,
  toCamelCase,
  toMacroCase,
  toSnakeCase,
  toScreamingSnakeCase,
  toKebabCase,
  toScreamingKebabCase,
  toPascalCase,
  toTitleCase
}
